module.exports = __webpack_public_path__ + "img/pg.50b57a36.svg";